module.exports = {
  clientId: 147143,
  email: 'twiqa+pexpdealer1@climate.com',
  firstName: 'PEXP',
  hybridUser: false,
  lastName: 'Dealer1',
  userType: 'dealer representative',
  countryCode: 'BR',
};
